import { useState } from 'react';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import { copyToClipboard } from '../utils/clipboardUtils';

export function useCopyFeedback() {
  const { t } = useTranslation();
  const [copyFeedback, setCopyFeedback] = useState<{
    show: boolean;
    message: string;
    severity: 'success' | 'error';
  }>({ show: false, message: '', severity: 'success' });

  const handleCopy = async (text: string, label: string) => {
    const success = await copyToClipboard(text);
    setCopyFeedback({
      show: true,
      message: success
        ? t(
            'dashboard.entityDetails.copySuccess',
            '{{label}} copied to clipboard!',
            {
              label,
            }
          )
        : t('dashboard.entityDetails.copyError', 'Failed to copy to clipboard'),
      severity: success ? 'success' : 'error',
    });
  };

  const closeCopyFeedback = () => {
    setCopyFeedback({ ...copyFeedback, show: false });
  };

  return {
    copyFeedback,
    handleCopy,
    closeCopyFeedback,
  };
}
